<template>
  <div class="columns">
    <label
      :class="{
        error: v.template.body.$error || errorsMessageBody.length > 0,
      }"
    >
      {{ $t('WHATSAPP_TEMPLATES.ADD.FORM.CONTENT.BODY.LABEL') }}
      <fluent-icon
        icon="info"
        size="14"
        v-tooltip.top-start="
          $t('WHATSAPP_TEMPLATES.ADD.FORM.CONTENT.BODY.TOOLTIP')
        "
      />

      <textarea
        v-model.lazy.trim="template.body"
        type="text"
        :placeholder="
          $t('WHATSAPP_TEMPLATES.ADD.FORM.CONTENT.BODY.PLACEHOLDER')
        "
        rows="4"
        minlength="1"
        maxlength="1024"
        @blur="v.template.body.$touch"
      />

      <span v-if="v.template.body.$error" class="message">
        {{ $t('WHATSAPP_TEMPLATES.ADD.FORM.CONTENT.BODY.ERROR') }}
      </span>

      <span class="message" v-for="(error, index) in errorsMessageBody" :key="index">
        {{ error }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    errorsMessageBody: {
      type: Array,
      default: [],
    },
    template: {
      type: Object,
      default: {},
    },
    v: {
      type: Object,
      default: () => {},
    },
  },
};
</script>